import { ResetPasswordPage } from 'components/pages/reset-password'
import { publicEnv } from 'env'
import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import { Routes } from 'routes'

const Page: NextPage = () => {
  return (
    <>
      <NextSeo title="パスワードを忘れた場合 | HoteCo" openGraph={{ url: `${publicEnv.host}${Routes.resetPassword()}` }} />
      <ResetPasswordPage />
    </>
  )
}

export default Page
